import gql from 'graphql-tag';

export const mutationDeleteIntegrationThread = gql`
  mutation deleteIntegrationThread (
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    deleteIntegrationThread (
      integrationID: $integrationID
      remoteID: $remoteID
    )
  }
`;
export default mutationDeleteIntegrationThread;
